

export const TOP_AND_BOTTOM_TOPICS_DATA_TAG="DATATAG_G6_DELIGHT_TOP_BOTTOM_TOPICS"
export const TOP_AND_BOTTOM_TOPICS_API_TAG="APITAG_G6_DELIGHT_TOP_N_BOTTOM_TOPICS"
export const TOP_AND_BOTTOM_TOPICS_WIDGET_ID="top_and_bottom_topics_widget"